import { z } from 'zod';
/** All bounds are centralized so API, forms, and tests cannot drift. */
export const supportContractLimits = Object.freeze({
    name: 120,
    email: 254,
    messageMin: 10,
    messageMax: 5_000,
    note: 5_000,
    search: 120,
    pageSize: 100,
    registrationMatches: 25,
    eventValue: 120,
    eventDetail: 500,
    sideEffectCode: 64,
    sideEffectMessage: 500,
    triageSummary: 500,
    triageReason: 1_000,
    retentionHoldReason: 1_000,
    registrationText: 254,
    sourceId: 128,
    runReference: 120,
});
export const supportRequestCategories = ['general', 'support', 'account_deletion'];
export const supportRequestCategorySchema = z.enum(supportRequestCategories);
export const supportRequestStatuses = ['new', 'in_progress', 'resolved', 'closed', 'spam'];
export const supportRequestStatusSchema = z.enum(supportRequestStatuses);
export const supportSideEffectStatuses = ['disabled', 'pending', 'succeeded', 'failed'];
export const supportSideEffectStatusSchema = z.enum(supportSideEffectStatuses);
export const supportTriagePriorities = ['low', 'normal', 'high'];
export const supportTriagePrioritySchema = z.enum(supportTriagePriorities);
export const supportRequestEventTypes = [
    'created',
    'status_changed',
    'assignment_changed',
    'note_added',
    'retention_hold_changed',
    'triage_outcome',
    'notification_outcome',
    'redacted',
];
export const supportRequestEventTypeSchema = z.enum(supportRequestEventTypes);
/** UUIDs are the only support identifiers allowed to cross the wire. */
export const supportOpaqueIdSchema = z.uuid();
//# sourceMappingURL=common.js.map